export default "__VITE_ASSET__DC9LZD7g__"